var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteVisit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 63.095,
    viewBox: "0 0 53 63.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7295",
    "data-name": "Group 7295",
    transform: "translate(-4 -2)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6242",
    "data-name": "Path 6242",
    d: "M10,4.524V12.1H32.714V4.524A2.524,2.524,0,0,0,30.19,2H12.524A2.524,2.524,0,0,0,10,4.524Z",
    transform: "translate(9.143 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6243",
    "data-name": "Path 6243",
    d: "M4,6.524V9.048H57V6.524A2.524,2.524,0,0,0,54.476,4H6.524A2.524,2.524,0,0,0,4,6.524Z",
    transform: "translate(0 3.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6244",
    "data-name": "Path 6244",
    d: "M6,8l4.573,43.432a5.048,5.048,0,0,0,5.02,4.52H39.314a5.048,5.048,0,0,0,5.02-4.52L48.9,8ZM17.551,50.9a2.521,2.521,0,0,1-2.711-2.322l-2.524-32.81a2.524,2.524,0,0,1,2.322-2.711,2.5,2.5,0,0,1,2.711,2.322l2.524,32.81A2.524,2.524,0,0,1,17.551,50.9Zm12.425-2.516a2.524,2.524,0,1,1-5.048,0V15.571a2.524,2.524,0,1,1,5.048,0Zm10.088.194a2.524,2.524,0,1,1-5.032-.389l2.524-32.81a2.486,2.486,0,0,1,2.711-2.322,2.524,2.524,0,0,1,2.322,2.711Z",
    transform: "translate(3.048 9.143)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteVisit);
export default __webpack_public_path__ + "static/media/DeleteVisit.8f5b3e53d1f07fa010214695642861f5.svg";
export { ForwardRef as ReactComponent };